import { render, staticRenderFns } from "./DepartmentConfiguration.vue?vue&type=template&id=766ffe40&"
import script from "./DepartmentConfiguration.vue?vue&type=script&lang=js&"
export * from "./DepartmentConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports